<div class="pt-2 pl-2">
    <ag-grid-angular [headerHeight]="35" [rowHeight]="35" #accountGrid style="height: 500px; width: 100%;" (rowDoubleClicked)="navigate($event)" class="ag-theme-alpine" [rowData]="rowAccount" [columnDefs]="columnAccount" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>